import React, { useState } from 'react';
import { FadeIn } from './FadeIn';
import { Button } from './Button';
import { ShieldCheck, CheckCircle2Icon } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function OfferSection() {
  const [bump1, setBump1] = useState(false);
  const [bump2, setBump2] = useState(false);
  const basePrice = 6.39;
  const bumpPrice = 9;
  const total = basePrice + (bump1 ? bumpPrice : 0) + (bump2 ? bumpPrice : 0);
  const getCheckoutUrl = () => {
    if (bump1 && bump2) return 'https://www.nachogerberg.com/cart/42713374752839:1';
    if (bump1) return 'https://www.nachogerberg.com/cart/42713350897735:1';
    if (bump2) return 'https://www.nachogerberg.com/cart/42713369542727:1';
    return 'https://www.nachogerberg.com/cart/42659358638151:1';
  };
  return <section id="offer-section" className="py-12 md:py-24 bg-mint relative overflow-hidden" data-id="element-191">
      <div className="container mx-auto px-4 md:px-6 max-w-5xl relative z-10" data-id="element-192">
        <div className="bg-white rounded-2xl md:rounded-3xl shadow-2xl overflow-hidden flex flex-col md:flex-row" data-id="element-193">
          {/* Image Side */}
          <div className="md:w-2/5 bg-sage/10 p-4 md:p-8 flex items-center justify-center relative" data-id="element-194">
            <div className="absolute inset-0 bg-gradient-to-br from-sage/20 to-transparent pointer-events-none" data-id="element-195"></div>
            <div className="relative z-10 flex flex-row gap-3 w-full max-w-[280px] items-center justify-center" data-id="element-196">
              <img src="https://cdn.magicpatterns.com/uploads/kxzMxXAmgQv1NttwpamgJT/heylloyd-image-1775063615406.png" alt="Protocolo SOS 72H" className="w-1/2 rounded-lg shadow-lg transform -rotate-1" data-id="element-197" />
              <img src="https://cdn.magicpatterns.com/uploads/2badsTisbq4G6GTw6mQLpY/portada_bono_3.png" alt="Bono 1 - Tracker 72H" className="w-1/2 rounded-lg shadow-md transform rotate-1" data-id="element-198" />
            </div>
          </div>

          {/* Content Side */}
          <div className="md:w-3/5 p-4 md:p-12 flex flex-col justify-center text-center md:text-left" data-id="element-199">
            <FadeIn data-id="element-200">
              <h2 className="text-xl md:text-4xl font-bold mb-2 md:mb-6 text-forest" data-id="element-201">
                Tu transformación comienza hoy
              </h2>
              <p className="text-sm md:text-lg text-gray-600 mb-3 md:mb-8 leading-relaxed" data-id="element-202">
                Recupera tu abdomen plano y tu energía hoy mismo por una
                fracción de lo que cuesta una consulta nutricional o un
                suplemento de moda que no funciona. Accede al sistema completo
                ahora.
              </p>

              <div className="mb-3 md:mb-6 text-left" data-id="element-203">
                <p className="text-xs md:text-sm text-gray-500 uppercase tracking-wider font-semibold mb-2" data-id="element-204">
                  Tu pedido incluye:
                </p>
                <ul className="space-y-1 text-xs md:text-base text-gray-700" data-id="element-205">
                  <li className="flex items-center gap-2" data-id="element-206">
                    <ShieldCheck className="w-4 h-4 text-sage shrink-0" data-id="element-207" />
                    <span data-id="element-208">Protocolo SOS 72H (producto principal)</span>
                  </li>
                  <li className="flex items-center gap-2" data-id="element-209">
                    <ShieldCheck className="w-4 h-4 text-sage shrink-0" data-id="element-210" />
                    <span data-id="element-211">Bono #1 — Tracker 72H Claro</span>
                  </li>
                  <AnimatePresence data-id="element-212">
                    {bump1 && <motion.li initial={{
                    opacity: 0,
                    height: 0
                  }} animate={{
                    opacity: 1,
                    height: 'auto'
                  }} exit={{
                    opacity: 0,
                    height: 0
                  }} className="flex items-center gap-2 overflow-hidden" data-id="element-213">
                        <CheckCircle2Icon className="w-4 h-4 text-gold shrink-0" data-id="element-214" />
                        <span className="font-semibold text-forest" data-id="element-215">
                          Protocolo "Domingo de Rescate" — +$9 USD
                        </span>
                      </motion.li>}
                  </AnimatePresence>
                  <AnimatePresence data-id="element-216">
                    {bump2 && <motion.li initial={{
                    opacity: 0,
                    height: 0
                  }} animate={{
                    opacity: 1,
                    height: 'auto'
                  }} exit={{
                    opacity: 0,
                    height: 0
                  }} className="flex items-center gap-2 overflow-hidden" data-id="element-217">
                        <CheckCircle2Icon className="w-4 h-4 text-gold shrink-0" data-id="element-218" />
                        <span className="font-semibold text-forest" data-id="element-219">
                          SOS Viajes y Hoteles — +$9 USD
                        </span>
                      </motion.li>}
                  </AnimatePresence>
                </ul>
              </div>

              <div className="mb-3 md:mb-8 p-3 md:p-6 bg-mint/30 rounded-xl md:rounded-2xl border border-mint inline-block w-full md:w-auto" data-id="element-220">
                <p className="text-xs md:text-sm text-gray-500 uppercase tracking-wider font-semibold mb-1" data-id="element-221">
                  Oferta Especial — Todo por solo
                </p>
                <div className="flex items-baseline justify-center md:justify-start gap-2 md:gap-3" data-id="element-222">
                  <span className="text-xl md:text-2xl text-gray-400 line-through font-serif" data-id="element-223">
                    $
                    {bump1 || bump2 ? 30 + (bump1 ? 9 : 0) + (bump2 ? 9 : 0) : 30}{' '}
                    USD
                  </span>
                  <motion.span key={total} initial={{
                  scale: 1.15,
                  color: '#b8860b'
                }} animate={{
                  scale: 1,
                  color: '#2d4a3e'
                }} transition={{
                  duration: 0.4
                }} className="text-4xl md:text-5xl font-bold text-forest font-serif" data-id="element-224">
                    ${total.toFixed(2).replace('.', ',')}
                  </motion.span>
                </div>
                <p className="text-xs md:text-sm text-sage font-semibold mt-1" data-id="element-225">
                  ¡Ahorra más del 78%!
                </p>
              </div>

              <div className="flex flex-col items-center md:items-start gap-3" data-id="element-226">
                <Button className="w-full md:w-auto" checkoutUrl={getCheckoutUrl()} data-id="element-227" />
                <div className="flex items-center gap-2 text-xs md:text-sm text-gray-500" data-id="element-228">
                  <ShieldCheck className="w-4 h-4 text-sage" data-id="element-229" />
                  <span data-id="element-230">Descarga instantánea en PDF. Acceso de por vida.</span>
                </div>
              </div>
            </FadeIn>
          </div>
        </div>

        {/* Order Bumps */}
        <div className="mt-8 space-y-6" data-id="element-231">
          {/* Order Bump 1 */}
          <FadeIn data-id="element-232">
            <div className={`bg-white rounded-2xl shadow-xl border-2 overflow-hidden relative transition-colors duration-300 ${bump1 ? 'border-gold' : 'border-gold/40'}`} data-id="element-233">
              <div className="bg-gold text-forest text-center py-2 px-4" data-id="element-234">
                <span className="font-bold text-sm uppercase tracking-wider" data-id="element-235">
                  Altamente Recomendado — Opción #1
                </span>
              </div>
              <div className="flex flex-col md:flex-row" data-id="element-236">
                <div className="md:w-1/4 p-4 md:p-6 flex items-center justify-center bg-cream/50" data-id="element-237">
                  <img src="https://cdn.magicpatterns.com/uploads/rZEdKCov9CGs23sHxEd63Z/portada_order_bump_1.png" alt="Protocolo Domingo de Rescate" className="w-32 md:w-full max-w-[160px] rounded-lg shadow-md" data-id="element-238" />
                </div>
                <div className="md:w-3/4 p-5 md:p-6" data-id="element-239">
                  <h3 className="text-lg md:text-xl font-bold text-forest mb-2" data-id="element-240">
                    ¿Querés despertar el lunes sintiéndote ligera (y sin
                    culpas)?
                  </h3>
                  <p className="text-xs text-sage font-semibold uppercase tracking-wider mb-3" data-id="element-241">
                    El Protocolo "Domingo de Rescate"
                  </p>
                  <p className="text-sm text-gray-600 leading-relaxed mb-4" data-id="element-242">
                    El domingo suele ser el día donde todo el progreso de la
                    semana se pierde... pero ya no más. Con el Protocolo Domingo
                    de Rescate, vas a transformar las últimas 12 horas de tu fin
                    de semana en un "borrador mágico" para la inflamación.
                    Aprendé el ritual exacto de hidratación de choque, la cena
                    de transición "Zero Pressure" y el truco de 5 minutos para
                    drenar tu sistema linfático antes de dormir.
                  </p>
                  <label className={`flex items-center gap-3 cursor-pointer group rounded-xl p-4 border transition-colors duration-300 ${bump1 ? 'bg-gold/10 border-gold' : 'bg-mint/30 hover:bg-mint/50 border-mint'}`} data-id="element-243">
                    <input type="checkbox" checked={bump1} onChange={e => setBump1(e.target.checked)} className="w-5 h-5 rounded border-sage text-sage accent-sage shrink-0" data-id="element-244" />
                    <span className="text-sm md:text-base font-semibold text-forest" data-id="element-245">
                      Agregá el "Domingo de Rescate" a mi pedido por solo{' '}
                      <span className="text-gold font-bold" data-id="element-246">$9 USD</span>
                    </span>
                  </label>
                </div>
              </div>
            </div>
          </FadeIn>

          {/* Order Bump 2 */}
          <FadeIn delay={0.1} data-id="element-247">
            <div className={`bg-white rounded-2xl shadow-xl border-2 overflow-hidden relative transition-colors duration-300 ${bump2 ? 'border-gold' : 'border-gold/40'}`} data-id="element-248">
              <div className="bg-gold text-forest text-center py-2 px-4" data-id="element-249">
                <span className="font-bold text-sm uppercase tracking-wider" data-id="element-250">
                  Altamente Recomendado — Opción #2
                </span>
              </div>
              <div className="flex flex-col md:flex-row" data-id="element-251">
                <div className="md:w-1/4 p-4 md:p-6 flex items-center justify-center bg-cream/50" data-id="element-252">
                  <img src="https://cdn.magicpatterns.com/uploads/2nyjZC67G9FSQzk9rSNHL5/portada_order_bump_2.png" alt="SOS Viajes y Hoteles" className="w-32 md:w-full max-w-[160px] rounded-lg shadow-md" data-id="element-253" />
                </div>
                <div className="md:w-3/4 p-5 md:p-6" data-id="element-254">
                  <h3 className="text-lg md:text-xl font-bold text-forest mb-2" data-id="element-255">
                    No permitas que un viaje o una cena arruinen tu abdomen
                    plano
                  </h3>
                  <p className="text-xs text-sage font-semibold uppercase tracking-wider mb-3" data-id="element-256">
                    SOS Viajes y Hoteles: Guía de Supervivencia
                  </p>
                  <p className="text-sm text-gray-600 leading-relaxed mb-4" data-id="element-257">
                    Viajar o comer afuera no tiene por qué significar
                    despertarse hinchada y sin energía al día siguiente. En esta
                    guía rápida, te doy mis "Scripts de Supervivencia": qué
                    decirle exactamente al mozo para "blindar" tu plato, cómo
                    hackear el buffet del hotel para no tener picos de sueño a
                    media mañana y el kit de emergencia que debés llevar en tu
                    cartera.
                  </p>
                  <label className={`flex items-center gap-3 cursor-pointer group rounded-xl p-4 border transition-colors duration-300 ${bump2 ? 'bg-gold/10 border-gold' : 'bg-mint/30 hover:bg-mint/50 border-mint'}`} data-id="element-258">
                    <input type="checkbox" checked={bump2} onChange={e => setBump2(e.target.checked)} className="w-5 h-5 rounded border-sage text-sage accent-sage shrink-0" data-id="element-259" />
                    <span className="text-sm md:text-base font-semibold text-forest" data-id="element-260">
                      Agregá "SOS Viajes y Hoteles" a mi pedido por solo{' '}
                      <span className="text-gold font-bold" data-id="element-261">$9 USD</span>
                    </span>
                  </label>
                </div>
              </div>
            </div>
          </FadeIn>
        </div>

        {/* Summary + CTA below order bumps */}
        <div className="mt-8 bg-white rounded-2xl md:rounded-3xl shadow-xl p-6 md:p-10 text-center" data-id="element-262">
          <p className="text-xs md:text-sm text-gray-500 uppercase tracking-wider font-semibold mb-3" data-id="element-263">
            Tu pedido incluye:
          </p>
          <ul className="space-y-2 text-sm md:text-base text-gray-700 text-left max-w-md mx-auto mb-6" data-id="element-264">
            <li className="flex items-center gap-2" data-id="element-265">
              <ShieldCheck className="w-4 h-4 text-sage shrink-0" data-id="element-266" />
              <span data-id="element-267">Protocolo SOS 72H (producto principal)</span>
            </li>
            <li className="flex items-center gap-2" data-id="element-268">
              <ShieldCheck className="w-4 h-4 text-sage shrink-0" data-id="element-269" />
              <span data-id="element-270">Bono #1 — Tracker 72H Claro</span>
            </li>
            <AnimatePresence data-id="element-271">
              {bump1 && <motion.li initial={{
              opacity: 0,
              height: 0
            }} animate={{
              opacity: 1,
              height: 'auto'
            }} exit={{
              opacity: 0,
              height: 0
            }} className="flex items-center gap-2 overflow-hidden" data-id="element-272">
                  <CheckCircle2Icon className="w-4 h-4 text-gold shrink-0" data-id="element-273" />
                  <span className="font-semibold text-forest" data-id="element-274">
                    Protocolo "Domingo de Rescate" — +$9 USD
                  </span>
                </motion.li>}
            </AnimatePresence>
            <AnimatePresence data-id="element-275">
              {bump2 && <motion.li initial={{
              opacity: 0,
              height: 0
            }} animate={{
              opacity: 1,
              height: 'auto'
            }} exit={{
              opacity: 0,
              height: 0
            }} className="flex items-center gap-2 overflow-hidden" data-id="element-276">
                  <CheckCircle2Icon className="w-4 h-4 text-gold shrink-0" data-id="element-277" />
                  <span className="font-semibold text-forest" data-id="element-278">
                    SOS Viajes y Hoteles — +$9 USD
                  </span>
                </motion.li>}
            </AnimatePresence>
          </ul>

          <div className="mb-6 p-3 md:p-6 bg-mint/30 rounded-xl md:rounded-2xl border border-mint inline-block" data-id="element-279">
            <p className="text-xs md:text-sm text-gray-500 uppercase tracking-wider font-semibold mb-1" data-id="element-280">
              Oferta Especial — Todo por solo
            </p>
            <div className="flex items-baseline justify-center gap-2 md:gap-3" data-id="element-281">
              <span className="text-xl md:text-2xl text-gray-400 line-through font-serif" data-id="element-282">
                ${30 + (bump1 ? 9 : 0) + (bump2 ? 9 : 0)} USD
              </span>
              <motion.span key={total} initial={{
              scale: 1.15,
              color: '#b8860b'
            }} animate={{
              scale: 1,
              color: '#2d4a3e'
            }} transition={{
              duration: 0.4
            }} className="text-4xl md:text-5xl font-bold text-forest font-serif" data-id="element-283">
                ${total.toFixed(2).replace('.', ',')}
              </motion.span>
            </div>
            <p className="text-xs md:text-sm text-sage font-semibold mt-1" data-id="element-284">
              ¡Ahorra más del 78%!
            </p>
          </div>

          <div className="flex flex-col items-center gap-3" data-id="element-285">
            <Button className="w-full md:w-auto" checkoutUrl={getCheckoutUrl()} data-id="element-286" />
            <div className="flex items-center gap-2 text-xs md:text-sm text-gray-500" data-id="element-287">
              <ShieldCheck className="w-4 h-4 text-sage" data-id="element-288" />
              <span data-id="element-289">Descarga instantánea en PDF. Acceso de por vida.</span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}